
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/quickEditEngine/components/styles/quickEditCompPanelWrapper.scss.css.virtualfile';
        module.exports = {"quickEditCompPanelWrapper":"_quickEditCompPanelWrapper_123mk_1","fullHeight":"_fullHeight_123mk_18"};